import { Box, Container, Stack, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { SECTION_LIGHT, CHECKCIRCLE_SIZE } from '../theme'

interface OutcomesSectionProps {
    title?: string
    subtitle: string
    items: string[]
    color: string
}

export function OutcomesSection({
    title = "What you'll be able to do",
    subtitle,
    items,
    color,
}: OutcomesSectionProps) {
    return (
        <Box sx={{ ...SECTION_LIGHT }}>
            <Container maxWidth="md">
                <Box sx={{
                    background: `linear-gradient(135deg, ${color}20 0%, white 100%)`,
                    border: `1px solid ${color}20`,
                    borderRadius: 3,
                    p: { xs: 4, md: 6 },
                }}>
                    <Typography variant="h4" sx={{ mb: 1 }}>{title}</Typography>
                    <Typography color="text.secondary" sx={{ mb: 4, fontSize: '15px' }}>
                        {subtitle}
                    </Typography>
                    <Stack spacing={2}>
                        {items.map(outcome => (
                            <Box key={outcome} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                                <CheckCircleIcon sx={{ color: color, fontSize: CHECKCIRCLE_SIZE, mt: 0.2, flexShrink: 0 }} />
                                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>{outcome}</Typography>
                            </Box>
                        ))}
                    </Stack>
                </Box>
            </Container>
        </Box>
    )
}
